import { render, staticRenderFns } from "./DuplicateUnitGroupModal.vue?vue&type=template&id=2ad6802f&scoped=true&"
import script from "./DuplicateUnitGroupModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateUnitGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6802f",
  null
  
)

export default component.exports